import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPhone"><Path d="M9.5 20.5H14.5M5.5 1.5H18.5V22.5H5.5V1.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPhone;
